import { ELoginActions } from '../actions/login.actions';
import { LoginActions } from '../actions/login.actions';
import { initialLoginState, LoginState } from '../state/login.state';

export function loginReducer(state: LoginState = initialLoginState, action: LoginActions): LoginState {
  switch (action.type) {
    case ELoginActions.GetTokenSuccess: {
      return { ...state, customerToken: action.payload };
    }

    case ELoginActions.DeleteTokenSuccess: {
      return { ...state, customerToken: null };
    }

    default:
      return state;
  }
};
